module.exports = __webpack_public_path__ + "images/gazelle_smallf34f672d3bd14a18a25370cedcb6110f.png";